import { useRaceTimeout } from '@/hooks/use-race-timeout';
import { useNewUserStore } from '@/store/new-user-module';
import { toCouponDetailOrList } from '@tencent/wphk-components-discount-code/utils';
import { computed, toRefs } from 'vue';
import { useBiReport } from './use-bi-report';
import { useMerchantInfo } from '@/store/merchant-info-module';
import { useCouponRewardDialog } from './use-coupon-reward-dialog';

export function useNewUser() {
  // ---- store ----
  const newUserStore = useNewUserStore();

  // ---- hooks ----
  // 封装的上报和扩展字段
  const { biReport, biExt } = useBiReport();
  // store在race中初始化
  const { err, isTimeout, isReady, res } = useRaceTimeout({
    promise: newUserStore.init(),
  });
  // 迎新券详情弹层
  const { showCouponRewardDialog } = useCouponRewardDialog();
  // 根据商户的信息判断是否展示迎新活动
  const { isNeedShowAct } = toRefs(useMerchantInfo());

  // ---- data/computed ----
  // 券信息
  const couponInfo = computed(() => newUserStore.couponModule.discountCodeCoupon);
  // 是否展示新人组件
  const isShow = computed(() => isNeedShowAct.value
    && (!isReady.value || (!isTimeout.value && !err.value && res.value)));

  // ---- 事件 ----
  // 点击拉起券详情弹层
  function handleOpenRedeemCouponDialog() {
    biReport('confirmbtn_click');
    showCouponRewardDialog();
    // 运营活动-迎新奖赏-全城狂赏主页-确认领取弹窗曝光
    biReport('confirmpopup_brow');
  };
  // 点击跳转查看券列表
  function handleViewCoupon() {
    biReport('usebtn_click');
    toCouponDetailOrList(couponInfo.value, 'channel');
  };

  return {
    /** 是否ready */
    isReady,
    /** 券信息 */
    couponInfo,
    /** 上报的扩展字段 */
    biExt,
    /** 是否满足展示迎新组件 */
    isShow,
    /** 点击拉起券详情弹层 */
    handleOpenRedeemCouponDialog,
    /** 点击跳转券列表 */
    handleViewCoupon,
  };
}
